import _ from 'underscore';

export default function point(json) {
    return {
        type: 'Point',
        coordinates: _.first(json.center, 2)
    };
}



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/annotations/geometry/point.js